import React, { FC, ReactNode } from 'react'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { RADIUS } from '@/shared/styles/radii'

// Notion 流 dialog. header (13/500 + ✕ + border-bottom) + body + actions footer.
// caller は <DialogShell open={...} onClose={...} title="..." actions={...}>...</DialogShell>
interface DialogShellProps {
  open: boolean
  onClose: () => void
  title: ReactNode
  /** dialog footer の actions (= Cancel / Submit ボタン等). 任意. */
  actions?: ReactNode
  /** dialog の max-width. default sm. */
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  /** submit/close 中の操作禁止. */
  disabled?: boolean
  children: ReactNode
}

export const DialogShell: FC<DialogShellProps> = ({
  open,
  onClose,
  title,
  actions,
  maxWidth = 'sm',
  disabled,
  children,
}) => (
  <Dialog
    open={open}
    onClose={disabled ? undefined : onClose}
    maxWidth={maxWidth}
    fullWidth
    PaperProps={{
      // dialog.md 正典: 角丸 12px (theme 6px 基準 ×2)
      sx: { borderRadius: `${RADIUS.xl}px` },
    }}
    slotProps={{
      // 医療向けに弱めた暗オーバーレイ 0.3 (modals.md。Notion 実測 0.6 は使わない)
      backdrop: { sx: { backgroundColor: 'rgba(0, 0, 0, 0.3)' } },
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 3,
        py: 2,
        borderBottom: `1px solid ${colorTokens.border.subtle}`,
      }}
    >
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 500,
          color: 'text.primary',
        }}
      >
        {title}
      </Typography>
      <IconButton size="small" onClick={onClose} disabled={disabled}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    <DialogContent sx={{ px: 3, py: 2 }}>{children}</DialogContent>
    {actions && (
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          borderTop: `1px solid ${colorTokens.border.subtle}`,
        }}
      >
        {actions}
      </DialogActions>
    )}
  </Dialog>
)
